import React from 'react';

export const DocumentIcon = () => {
  return (
    <span
      title={'Documents'}
      className="solstice-icon- solstice-icon-note"
      style={{ color: '#757575', fontSize: '14px' }}
    />
  );
};
